import InfScr from './infscr'
import { ajaxUrl } from '../util/ajax_util'
import register from '../util/init'
import {VideoPlayer} from './videoplayer'

function feedIndex (container) {
  const contentSelector = '.media-listing'
  const nextSelector = '.next-link'
  const content = container.querySelector('.content')

  const scrollState = () => {
    if (content.querySelector(nextSelector)) {
      document.body.classList.add('infinite-scrolling')
    } else {
      document.body.classList.remove('infinite-scrolling')
    }
  }
  scrollState()

  const initContent = () => {
    Array(...content.querySelectorAll('.video-player')).forEach(playerEl => {
      if (!playerEl.getAttribute('video-initialised')) {
        new VideoPlayer(playerEl, {})
        playerEl.setAttribute('video-initialised', true)
      }
    })
    // Array(...this.flkty.element.querySelectorAll('.video-player'))
    //   .forEach(playerEl => {
    //     // console.log(playerEl)
    //     this.players.push(new VideoPlayer(playerEl, {
    //       handlers: {
    //         // ended: () => endedHandler,
    //         playing: () => playingHandler(true),
    //         pause: () => playingHandler(false)
    //       }
    //     }))
    //   })
  }

  initContent()

  const infscr = InfScr(content, {
    contentSelector: contentSelector,
    nextSelector: nextSelector,
    autoOffset: 1500,
    cache: false, // TODO turn on cache
    get_url: (link) => {
      return ajaxUrl(link.getAttribute('href'))
    },
    beforeLoad: function () {
      content.classList.add('loading-more')
    },
    onLoad: function (newContent, $container) {
      content.classList.remove('loading-more')
      scrollState()

      // TODO initialise videos - need to only initialise once because newContent
      // doesn't work atm
      initContent()
    }
  })

  return {
    resize: (...args) => infscr.resize(...args),
    scroll: (...args) => {
      infscr.scroll(...args)
    },
    teardown: () => {
      document.body.classList.remove('infinite-scrolling')
    }
  }
}
register('.feed-index', feedIndex)



// WEBPACK FOOTER //
// ./assets/j/src/feed.js